import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";

interface ConfirmTradeSelectionModalProps {
  isChange: boolean;
  isOpen: boolean;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tradeName: string;
}

const ConfirmTradeSelectionModal: React.FC<ConfirmTradeSelectionModalProps> = ({
  isChange,
  isOpen,
  isSaving,
  onClose,
  onConfirm,
  tradeName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          width: "500px",
          maxWidth: "calc(100vw - 32px)",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        {isChange ? "Change QuickBooks Trade" : "Set QuickBooks Trade"}
      </h3>
      <p className="mt-3 text-sm text-gray-600">
        Every customer and invoice imported from QuickBooks Online will be
        assigned to <span className="font-medium">{tradeName}</span>.
        <br />
        The trade can only be changed until your first import.
        <br />
        Are you sure you want to continue?
      </p>

      <div className="mt-6 flex justify-end space-x-3">
        <Button disabled={isSaving} onClick={onClose} variant="plain">
          Cancel
        </Button>

        <Button disabled={isSaving} onClick={onConfirm} variant="default">
          {isSaving ? "Saving..." : isChange ? "Change Trade" : "Save Trade"}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmTradeSelectionModal;
